import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import DishesWrap from '@/components/DishesWrap.vue'
import PyramidWrap from '@/components/PyramidWrap.vue'

import {i18n} from '../i18n/index.js'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/:lang',
      component: {
        render: h => h('router-view')
      },
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        
        if ( !['it','en'].includes(lang) ) {
          return next('en');
        }else{
          i18n.locale = lang
        }
      
        return next();
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: Home
        },
        {
          path: 'do-your-part-eat-smart',
          name: 'CardsGame',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '../components/CardsGameWrap.vue'),
          props: {isOverlay: false, startCardsOverlay: true}
        },
        {
          path: 'feed-a-sustainable-and-healthy-future',
          name: 'SdgSection',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ '../components/SdgSection.vue'),
          props: {isOverlay: false, startCardsOverlay: true}
        },
        {
          path: 'good-food-good-mood',
          name: 'DishesGame',
          component: () => import(/* webpackChunkName: "about" */ '../components/DishesWrap.vue'),
          props: { isOverlay: false, startDishesOverlay: true },
        },
        {
          path: 'better-meals-better-planet',
          name: 'Pyramid',
          component: () => import(/* webpackChunkName: "about" */ '../components/PyramidWrap.vue'),
          props: { isOverlay: false, startPyramidOverlay: true }
        },
        {
          path: 'download',
          name: 'Download',
          component: () => import(/* webpackChunkName: "about" */ '../components/Download.vue'),
          props: { isOverlay: false}
        }

      ]
    },
    {
      path: '/',
      name: 'Root',
      component: Home,
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        
        if ( !['it','en'].includes(lang) ) {
          return next('en');
        }else{
          i18n.locale = lang
        }
        return next()
      }
        
    }
  ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
